// Moved to its own type in order to improve error messages
type AnyFunction = (...args: any[]) => any;

/**
 * Adapt a vivaa-api client method to be used with TanStack Query.
 */
export function getQueryProps<
  TFunctionName extends keyof TClient & string,
  TClient extends Record<TFunctionName, AnyFunction> & {
    baseEndpoint: string;
  },
>(
  // Take in client and function name separately to avoid forcing callers
  // to bind the function to the client themselves.
  client: TClient,
  functionName: TFunctionName,
  ...args: Parameters<TClient[TFunctionName]>
): {
  queryKey: unknown[];
  queryFn: () => ReturnType<TClient[TFunctionName]>;
} {
  return {
    queryKey: [`${client.baseEndpoint}:${functionName}`, ...args],
    // The return type is set correctly on our type signature, but inside this
    // function it's inferred as `any`.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    queryFn: () => client[functionName](...args),
  };
}
